import styled from 'styled-components';
import { resolveColor } from 'ui/styles/utils/colors';
import { query } from 'ui/styles/queries';
import Header from 'src/ui/atoms/header';

export const ProductInfo = styled.div`
  margin: 0 auto;
  border-radius: 1rem;
  padding: 1rem;
  background-color: ${({ theme }) => resolveColor(theme, 'grayLight')};
  margin-bottom: 1rem;

  ${query.phone`
    margin: 1rem;
    margin-top: 0;
  `};
`;

export const Step = styled.div`
  display: flex;
`;

export const RadioContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const LabelRadio = styled(Header)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1rem 0 0;
`;

export const Row = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 1rem;
`;

export const Column = styled.div`
  flex: 1;
`;
